// extracted by mini-css-extract-plugin
export default {"layout":"_0f62a44ffc ecf0a8ac61 adf25c0319","h_slide":"_9c00acc325","category":"_89a651cd73 b82e1d7cc7 _3baacf0b79"};